import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, Typography, Button, Modal, IconButton } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { shopData } from "./Categorys";
import { Phone } from "@mui/icons-material";
import { useEffect, useState, useMemo, useRef } from "react";
import { ProductList } from "../../components";
import CloseIcon from "@mui/icons-material/Close";
import {
  GoogleMap,
  MarkerF,
  useJsApiLoader,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { useSelector } from "react-redux";
import { getShopdetails } from "../../store/actions/userActions";
import { useDispatch } from "react-redux";
import { useFetch, useFetchById } from "../../hooks";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import ShareIcon from "@mui/icons-material/Share";
import useShopSeo from "../../components/SEO/useShopSeo";
import { describeShop } from "../../components/SEO/shopSeo";
import usePublicShop from "../../hooks/usePublicShop";

const formatVendor = (item) => ({
  id: item.id,
  name: item.name,
  shopName: item.shop_name,
  description:
    Array.isArray(item.categories) && item.categories.length > 0
      ? item.categories.map((c) => c.description).join(", ")
      : Array.isArray(item.listCategories) && item.listCategories.length > 0
        ? item.listCategories.map((c) => c.description).join(", ")
        : "",
  image: item.store_image,
  distance: item.distance ? `${item.distance} km from you` : "N/A",
  rating: "4.8",
  address: `${item.street}, ${item.city}, ${item.state}, ${item.country}, ${item.pincode}`,
  street: item.street,
  city: item.city,
  state: item.state,
  pincode: item.pincode,
  openTime: item.open_time,
  closeTime: item.close_time,
  latitude: item.latitude,
  longitude: item.longitude,
  phoneNumber: item.phone_number,
  regularListType: item.reg_list_type,
});

const ShopDetails = () => {
  const loginToken = useSelector((state) => state.user.logintoken);
  const userDetails = useSelector((state) => state.user.userdetails);
  const userVtype = userDetails?.vtype;
  const latitude = useSelector(
    (state) => state.user?.userLocation?.latitude ?? null,
  );
  const longitude = useSelector(
    (state) => state.user?.userLocation?.longitude ?? null,
  );
  const apptoken = useSelector((state) => state.user.apptoken);
  const [vendors, setVendors] = useState([]);
  console.log("userType", userVtype);
  const {
    data: vProductsData,
    error: vProductsDataError,
    fetchDataById: fetchVProductsByID,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: productListingData,
    error: productListingError,
    fetchDataById: productListingFetchData,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const vendorListUrl =
    latitude && longitude
      ? `${BASE_URL_TEST}/api/main/vendors?lat=${latitude}&lng=${longitude}&radius=20&vtype=regular`
      : null;
  const {
    data: vendorData,
    isLoading: isVendorListLoading,
    fetchData: fetchVendorList,
  } = useFetch(vendorListUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (apptoken) {
      fetchVendorList();
    }
  }, [apptoken, latitude, longitude]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  const { slug } = useParams();
  // Extract the ID from the slug (assumes ID is after last hyphen)
  const slug_id = slug ? slug.split("-").pop() : undefined;

  console.log("Extracted ID from slug:", slug_id);
  const { state } = useLocation();
  const navigate = useNavigate();
  console.log("state", state);
  // Loaded by id so direct visits (shared links, Google) work without the
  // visitor's location; also gives the real rating and SEO details.
  const publicShop = usePublicShop(slug_id);
  const shop = state?.shop
    ? state.shop
    : vendors.find((v) => String(v.id) === String(slug_id)) ||
      (publicShop ? formatVendor(publicShop) : undefined);
  useShopSeo(publicShop);
  const [openMapModal, setOpenMapModal] = useState(false);

  console.log("shopDetails shop", shop);
  const [directions, setDirections] = useState(null);
  const dispatch = useDispatch();
  const handleOpenMap = () => setOpenMapModal(true);
  const handleCloseMap = () => setOpenMapModal(false);
  const startLat = useSelector(
    (state) => state.user?.userLocation?.latitude ?? null,
  );
  const [allProdListingData, setAllProdListingData] = useState([]);
  const [allVendorProdData, setAllVendorProductsData] = useState([]);
  const startLng = useSelector(
    (state) => state.user.userLocation?.longitude ?? null,
  );
  const origin = { lat: parseFloat(startLat), lng: parseFloat(startLng) };
  const customerId = useSelector((state) => state.user.customerId);
  const destination = {
    lat: parseFloat(shop?.latitude),
    lng: parseFloat(shop?.longitude),
  };
  let vProductsById = "";
  dispatch(getShopdetails(shop));

  useEffect(() => {
    if (vendorData && vendorData.vendors) {
      const formattedVendors = vendorData.vendors.map(formatVendor);
      setVendors(formattedVendors);
    }
  }, [vendorData]);

  useEffect(() => {
    console.log("useEffect called", userVtype);
    let vProductsById = "";

    // console.log("catByIdUrl",formValues)
    if (slug_id && userVtype === "vendor") {
      vProductsById = urls("getAllVProducts", slug_id);
      fetchVProductsByID(vProductsById);
    } else if (slug_id && userVtype === "vlistuser") {
      vProductsById = urls("getAllVListingById", slug_id);
      productListingFetchData(vProductsById);
    } else {
      vProductsById = urls("getAllVProducts", slug_id);
      fetchVProductsByID(vProductsById);
    }
  }, [slug_id, userVtype]);

  useEffect(() => {
    if (vProductsDataError) {
    } else if (vProductsData && vProductsData["status"] == true) {
      setAllVendorProductsData(vProductsData["data"]);
    }
  }, [vProductsData, vProductsDataError]);

  useEffect(() => {
    if (productListingError) {
    } else if (productListingData && productListingData.status == true) {
      setAllProdListingData(productListingData["data"]);
    }
  }, [productListingData, productListingError]);

  // useEffect(() => {
  //   if (!window.google) return;
  //   const directionsService = new window.google.maps.DirectionsService();

  //   directionsService.route(
  //     {
  //       origin,
  //       destination,
  //       travelMode: window.google.maps.TravelMode.DRIVING,
  //     },
  //     (result, status) => {
  //       if (status === window.google.maps.DirectionsStatus.OK) {
  //         setDirections(result);
  //       } else {
  //         console.error("Directions error:", status);
  //       }
  //     },
  //   );
  // }, []);

  useEffect(() => {
    if (!window.google || !shop || !startLat || !startLng) return;

    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
        origin,
        destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK") {
          setDirections(result);
        } else {
          console.error(status);
        }
      },
    );
  }, [shop, startLat, startLng]);

  const pathCoordinates = useMemo(() => {
    if (
      startLat &&
      startLng &&
      shop?.latitude &&
      shop?.longitude &&
      !isNaN(startLat) &&
      !isNaN(startLng)
    ) {
      return [
        { lat: parseFloat(startLat), lng: parseFloat(startLng) },
        { lat: parseFloat(shop?.latitude), lng: parseFloat(shop?.longitude) },
      ];
    }
    return [];
  }, [startLat, startLng, shop?.latitude, shop?.longitude]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8",
  });

  const containerStyle = {
    width: "100%",
    height: "450px",
    borderRadius: "8px",
  };

  const mapRef = useRef(null);

  const dataset =
    userVtype === "vendor" ? allVendorProdData : allProdListingData;

  console.log("shopDetails dataset", dataset);

  const onLoad = (map) => {
    mapRef.current = map;
  };

  useEffect(() => {
    if (
      openMapModal &&
      mapRef.current &&
      window.google &&
      window.google.maps?.event
    ) {
      window.google.maps.event.trigger(mapRef.current, "resize");
    }
  }, [openMapModal]);

  const handlePhone = () => {
    console.log("Button clicked");
    if (shop?.phoneNumber) {
      window.location.href = `tel:${shop.phoneNumber}`;
    } else {
      console.log("No phone number available");
    }
  };

  if (!shop && !slug_id) {
    return (
      <Typography variant="h6" sx={{ textAlign: "center", marginTop: 4 }}>
        Shop not found
      </Typography>
    );
  }

  // const handleShare = async () => {
  //   const shareUrl = `${window.location.origin}/shop/${slug}`;

  //   const shareData = {
  //     title: shop?.shopName,
  //     text: `${shop?.shopName} on LocalMart!\n\n📍 ${shop?.address}\n📞 ${shop?.phoneNumber}`,
  //     url: shareUrl,
  //   };

  //   try {
  //     if (navigator.share) {
  //       // Mobile browsers
  //       await navigator.share(shareData);
  //     } else {
  //       // Desktop browsers
  //       await navigator.clipboard.writeText(
  //         `${shareData.text}\n${shareData.url}`,
  //       );

  //       alert("Shop link copied to clipboard!");
  //     }
  //   } catch (error) {
  //     console.log("Share cancelled", error);
  //   }
  // };

  const handleShare = async () => {
    const url = window.location.href;

    if (navigator.share) {
      await navigator.share({
        title: shop.shopName,
        text: shop.description,
        url,
      });
    } else {
      navigator.clipboard.writeText(url);
      alert("Link copied");
    }
  };

  return (
    shop && (
      <Box sx={{ padding: 2, maxWidth: "1200px", margin: "0 auto" }}>
        {state?.shop ? (
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{ marginBottom: 2, fontSize: "1rem", textTransform: "none" }}
          >
            Back
          </Button>
        ) : null}

        <Box
          component="img"
          src={shop.image}
          alt={shop.name}
          sx={{
            width: "100%",
            maxHeight: { xs: "200px", sm: "300px", md: "400px" },
            borderRadius: "8px",
            objectFit: "cover",
            fontSize: "1.5rem",
          }}
        />

        <Box sx={{ padding: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: "bold",
                textAlign: "left",
                fontSize: "1.75rem",
              }}
            >
              {shop.shopName} ({shop?.regularListType})
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center" }}>
              <StarIcon sx={{ color: "#FFA500", marginRight: 0.5 }} />
              <Typography variant="body2" sx={{ color: "#FFA500" }}>
                {publicShop
                  ? publicShop.rating
                    ? `${publicShop.rating.value} (${publicShop.rating.count})`
                    : "New"
                  : ""}
              </Typography>
            </Box>
          </Box>

          <Typography
            variant="body2"
            sx={{
              backgroundColor: "#FFF4E5",
              color: "#FF6F00",
              display: "inline-block",
              padding: "4px 8px",
              borderRadius: "4px",
              marginBottom: 2,
            }}
          >
            {shop.description}
          </Typography>

          <Typography variant="body1" sx={{ marginTop: 2 }}>
            Opening Timings:{" "}
            <strong>
              {shop.openTime} to {shop.closeTime}
            </strong>
          </Typography>
          {publicShop && (
            <Typography
              variant="body2"
              sx={{ marginTop: 2, color: "text.secondary" }}
            >
              {describeShop(publicShop)}
            </Typography>
          )}

          <Box sx={{ display: "flex", alignItems: "center", marginTop: 2 }}>
            <LocationOnIcon sx={{ color: "#FF6F00", marginRight: 1 }} />
            <Typography variant="body2">{shop.address}</Typography>
          </Box>

          <Box
            sx={{
              display: "flex",

              alignItems: "center",
              marginTop: 2,
            }}
          >
            <Typography variant="body2">{shop.distance} </Typography>
            {/* <Typography
            variant="body2"
            sx={{
              color: "#007BFF",
              textDecoration: "underline",
              cursor: "pointer",
              marginLeft: 2,
            }}
          >
            Distance: Dynamic
          </Typography> */}
          </Box>

          <Box
            sx={{
              display: "flex",
              marginTop: 3,
            }}
          >
            <Button
              variant="outlined"
              sx={{
                color: "#FF6F00",
                borderColor: "#FF6F00",
                "&:hover": {
                  backgroundColor: "#FFF4E5",
                  borderColor: "#FF6F00",
                },
                textTransform: "none",
              }}
              startIcon={<LocationOnIcon />}
              onClick={handleOpenMap}
            >
              Direction
            </Button>

            {customerId && (
              <Button
                variant="outlined"
                // onClick={handlePhone}
                startIcon={<Phone />}
                sx={{
                  color: "#FF6F00",
                  borderColor: "#FF6F00",
                  "&:hover": {
                    backgroundColor: "#FFF4E5",
                    borderColor: "#FF6F00",
                  },
                  marginLeft: 2,
                  textTransform: "none",
                }}
              >
                {shop?.phoneNumber}
              </Button>
            )}

            <Button
              variant="outlined"
              onClick={handleShare}
              startIcon={<ShareIcon />}
              sx={{
                color: "#FF6F00",
                borderColor: "#FF6F00",
                marginLeft: 2,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#FFF4E5",
                  borderColor: "#FF6F00",
                },
              }}
            >
              Share
            </Button>
          </Box>
        </Box>

        {/* will have all products here */}
        <ProductList slugid={slug_id} />
        <Modal open={openMapModal} onClose={handleCloseMap}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              maxWidth: "800px",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 2,
              borderRadius: 2,
              outline: "none",
            }}
          >
            <IconButton
              onClick={handleCloseMap}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 10,
                color: "#555",
              }}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Map to: {shop.name}
            </Typography>

            {isLoaded && (
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={{
                  lat:
                    ((pathCoordinates?.[0]?.lat || 0) +
                      (pathCoordinates?.[1]?.lat || 0)) /
                    2,
                  lng:
                    ((pathCoordinates?.[0]?.lng || 0) +
                      (pathCoordinates?.[1]?.lng || 0)) /
                    2,
                }}
                zoom={13}
                onLoad={(map) => {
                  onLoad(map);

                  if (directions) {
                    const bounds = new window.google.maps.LatLngBounds();
                    bounds.extend(pathCoordinates[0]);
                    bounds.extend(pathCoordinates[1]);
                    map.fitBounds(bounds);
                  }
                }}
              >
                {directions && (
                  <DirectionsRenderer
                    directions={directions}
                    options={{
                      suppressMarkers: true,
                      polylineOptions: {
                        strokeColor: "#FF0000",
                        strokeWeight: 4,
                      },
                    }}
                  />
                )}
                {pathCoordinates.length === 2 && (
                  <>
                    {/* Customer Marker */}
                    <MarkerF
                      position={pathCoordinates[0]}
                      title="Customer Location"
                      label={{
                        text: "C",
                        color: "#FFFFFF",
                        fontWeight: "bold",
                        fontSize: "14px",
                      }}
                      icon={{
                        path: window.google.maps.SymbolPath.CIRCLE,
                        scale: 14,
                        fillColor: "#2E7D32",
                        fillOpacity: 1,
                        strokeColor: "#FFFFFF",
                        strokeWeight: 2,
                      }}
                    />

                    {/* Vendor Marker */}
                    <MarkerF
                      position={pathCoordinates[1]}
                      title="Vendor Location"
                      label={{
                        text: "V",
                        color: "#FFFFFF",
                        fontWeight: "bold",
                        fontSize: "14px",
                      }}
                      icon={{
                        path: window.google.maps.SymbolPath.CIRCLE,
                        scale: 14,
                        fillColor: "#D32F2F",
                        fillOpacity: 1,
                        strokeColor: "#FFFFFF",
                        strokeWeight: 2,
                      }}
                    />
                  </>
                )}
              </GoogleMap>
            )}
          </Box>
        </Modal>
      </Box>
    )
  );
};

export default ShopDetails;
